import { render, staticRenderFns } from "./MapSidebar.vue?vue&type=template&id=3bd4f70b"
import script from "./MapSidebar.vue?vue&type=script&lang=js"
export * from "./MapSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports